<div class="text-center">
  <span class="spin"></span>
  <p class="my-0 text-rich text-secondary-light">{{'label.Loading' | translate}}...</p>
</div>
